import { Component, OnInit, EventEmitter } from '@angular/core';
import { GeneralFormComponent } from 'src/app/components/controls/general-form/general-form.component';
import { StaticData } from '../../../helpers/static-data';
import { DataTableComponent } from '../../controls/data-table/data-table.component';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-document-validate-external-pqrs',
  templateUrl: './document-validate-external-pqrs.component.html',
  styleUrls: ['./document-validate-external-pqrs.component.scss']
})
export class DocumentValidateExternalPqrsComponent extends GeneralFormComponent implements OnInit {

  FirstLoadDatatable: any = 0;
  CurrentItemGrid: any;
  UserData: any;
  DatosUsuario: any;
  DatosIngreso: any;
  DocumentosSolicitud: any;
  GridViewExternalPQRs: any;
  DatosValidos: any = false;
  Meses: any = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Dicembre"];

  public OnInitEnd() {
    debugger;

    this.GridViewExternalPQRs = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "GridViewExternalPQRs" });
    this.DocumentosSolicitud = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "DocumentosSolicitud" });

    if (StaticData.ExternalPqrContact != null && StaticData.ExternalPqrContact != undefined){
      this.UserData = StaticData.ExternalPqrContact != undefined ? JSON.parse(StaticData.ExternalPqrContact) : StaticData.ExternalPqrContact;
      this.DatosUsuario = this.UserData.NombreCompleto + ', ID ' + this.UserData.Identificacion;
      let FechaIngreso = new Date();
      this.DatosIngreso = 'Fecha de ingreso a las ' + (FechaIngreso.getHours().toString().length == 1 ? '0' + FechaIngreso.getHours() : FechaIngreso.getHours()) + ":" + (FechaIngreso.getMinutes().toString().length == 1 ? '0' + FechaIngreso.getMinutes() : FechaIngreso.getMinutes()) + ', ' + FechaIngreso.getDate() + ' de ' + this.Meses[(FechaIngreso.getMonth())] + ', ' + FechaIngreso.getFullYear();
    }
  }

  /*public OnActionEventHandler(event) {
    debugger;
  }*/

  public AddComponentInstanceHandler(event) {
    debugger;
    if (event instanceof DataTableComponent) {
      if (event.name == 'GridViewExternalPQRs') {
        this.SetProcesando(true);
        event.QueryConfig.Entity.NumeroRadicado = '1';
        event.QueryConfig.Entity.CodigoVerificacion = '1';
        event.cargarGrilla = true;
        event.ReCargarGrilla();
        this.SetProcesando(false);
      }
      this.componentsContainer.Tables.push(event);

    }
    else {
      super.AddComponentInstanceHandler(event);
    }
  }

  public OnLoadGridHandler(event)
  {
      debugger;
      this.FirstLoadDatatable += 1;
      if(this.FirstLoadDatatable > 2)
      {
        if(event.data.length == 0)
        {
          this.DocumentosSolicitud.Hidden = true;
          this.utility.VerModalWarning({"titulo": "Datos Incorrectos", "descripcion":  "El Número de radicado y el código de verificación ingresados no coinciden o no existen en el sistema. \t\n Por favor verifique la información e intentelo nuevamente"});
        }
      }
      
  }

  public OnDataTableEditHandler(event) {
    debugger;
    if (event.name == 'GridViewExternalPQRs') {

      /*this.CurrentItemGrid = event.modelo.currentItem;
      this.modelo.modelo.IdSolicitudPqrd = this.CurrentItemGrid.IdSolicitudPqrd;*/
      this.DocumentosSolicitud.Hidden = false;
      console.log(this.modelo.modelo.IdSolicitudPqrd);
      console.log(this.modelo.modelo.IdSolicitudRadicadoSalida);

    }

  }

  public OnActionEventHandler(event) {
    debugger;
    if (event.Name == "Buscar") {
      this.ValidarRadicadoMasCodigo(event);

      if(!this.DatosValidos)
      {
        
        this.GridViewExternalPQRs.Hidden = true;
        
      }
      
    }
  }


  SalidaPqrs($event) {
    debugger;
    this.LimpiarSesion();
  }

  public LimpiarSesion() {
    debugger;

    this.DatosUsuario = null;
    this.DatosIngreso = null;
    var CurrentUrl = window.location.href;
    StaticData.ContactAuthenticated = false;
    window.location.href = CurrentUrl.replace('ValidarDocumentoExternalPqrs', 'HomeExternalPQR');
  }

  public ValidarRadicadoMasCodigo(event) {
    debugger;
    var obj = this.utility.GetApiModel('ConsultaRadicadoMasVerificacionExternalPqr', this.componentName);

    obj.QueryConfig.Command = 'ConsultaRadicadoMasVerificacionExternalPqr';
    obj.QueryConfig.IsSp = true;
    debugger;
    obj.QueryConfig.Entity = { NumeroRadicado: this.modelo.modelo.NumeroRadicado, CodigoVerificacion: this.modelo.modelo.CodigoVerificacion };

    this.baseService.Get(obj, null,
      {
        componentName: this.componentName,
        method: 'ConsultaRadicadoMasVerificacionExternalPqr',
        processMessage: 'Verificando Número de radicado mas código de verificación...'
      }, 'RUsuario')
      .then(data => {
        debugger;
        if (data.Data[0].Message != null || data.Data[0].Message != undefined) {
          this.DatosValidos = false;
          this.utility.VerModalWarning({
            titulo: 'Alerta', descripcion: data.Data[0].Message,
            verOk: true, verCancelar: false, ok: 'Aceptar', cancelar: 'NO'
          }).then(data => { });
        }
        else {
          this.DatosValidos = true;
          this.modelo.DataAdd =
          {
            NumeroRadicado: this.modelo.modelo.NumeroRadicado,
            CodigoVerificacion: this.modelo.modelo.CodigoVerificacion
          }
          this.GridViewExternalPQRs.Hidden = false;
        
          this.helperActions.ExecuteActionsControl((event.Option) ? event.Option : event.config,
          false, null, this.modelo, this.permissionsConfig,
          this, null, new EventEmitter<any>(), this.componentsContainer,
          event.Option, this.modelo.modeloMetadata, { importUrl: this.importUrl });
        }

      }).catch(err => {
        this.utility.logger.LogError(err, obj, {
          componentName: this.componentName,
          method: 'ConsultaRadicadoMasVerificacionExternalPqr',
          processMessage: 'Verificando Número de radicado mas código de verificación...'
        }, 'RUsuario')
      });
  }

}
